import React, { useEffect, useState, useMemo, useCallback } from 'react'
import classes from './Stats2.module.css'
import usersIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import allSitesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png'
import OnlineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/online.png'
import OfflineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/offline.png'
import SpinnerIcon from '../../../assets/portalAssets/spinner.png'
import padlockIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/locks.png'
import gatewayIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png'
import sensorIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sensor.png'
import keyBoxesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/keybox.png'
import unlinkedIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unlinked.png'
import activeLock from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeLock.png'
import groupsIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/groups.png'
import usersIcon2 from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import IDIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ID.png'
import portalNameIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/portalName.png'
import appNameIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/appName.png'
import firmwareIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/firmware.png'
import IPIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ipIcon.png'
import macIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/mac.png'
import statusIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/status.png'
import suspendedIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/suspended.png'
import createdIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/created.png'
import cctvType from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png'
import deviceType from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/type.png'
import monitored from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/monitor.png'
import serial from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/serial.png'
import restriction from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/restriction.png'
import phoneIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/phone.png'
import activeIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeSidebar.png'
import inactiveIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/inactiveSidebar.png'
import origin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/origin.png'
import usedBy from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/usedBy.png'
import ownedBy from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ownedBy.png'
import billedTo from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/billedTo.png'
import battery from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery.png'
import battery0 from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/critical-battery.png'
import battery25 from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/warning-battery.png'
import battery100 from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/healthy-battery.png'

import signal from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_100.png'
import master from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/master.png'
import timezone from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/world.png'
import billable from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/billedTo.png'
import deviceIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/deviceType.png'
import controllerIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/controller.png'
import empty from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/empty.png'
import lastloggedin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/lastloggedin.png'
import cloud from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cloud.png'
import enabled from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/bell.png'
import portalAdmin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/adminStats.png'
import userSince from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/userSince.png'
import sitesOnSchedule from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/schedule.png'
import placeholder from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/placeholder.png'
import holidayIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hmIcon.png'
import gatewayIconG from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortalG.png'
import ajaxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import dahuaIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import hikIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import aiboxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import liveViewIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/liveView.png'
import cameraIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png'
import tempIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/deadline.png'
import editIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/pencil.png'
import world from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/world.png'
import siteTypeIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/siteType.png'
import unstableCCTV from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unstable_cctv.png'
import liveViewNewIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/liveView2.png'
import licenceIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/license.png'
import customerIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/customerNumber.png'
import power from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/power.png'
import arm from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/armIcon.png'
import disarm from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/disarmIcon.png'
import timer from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/timer.png'
import schedule from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/scheduleIcon.png'
import success from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/successIcon.png'

import TimerIndicator from './Stats2/TimerIndicator'
import { Oval } from 'react-loading-icons'
import { useNavigate } from 'react-router-dom'
import DataManager from '../../../hooks/DataManager'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar';
import { Button } from 'rsuite'
import { act } from 'react'
import { linkGateway } from '../../../Api Methods/Api'
import mixpanel from 'mixpanel-browser'


const Stats2 = ({ 
    title, 
    value, 
    status, 
    isLoadingStats, 
    isStatic, 
    changeNotifications, 
    setChangeNotifications, 
    changePortalAdmin, 
    setChangePortalAdmin, 
    setHolidayModeFilter, 
    allSitesFilter, 
    monitoredByOptions, 
    monitoredBy, 
    setMonitoredBy, 
    showMonitoredByDropdown, 
    setShowMonitoredByDropdown, 
    setShowChangeGroup, 
    setShowChangePortalName, 
    setShowChangeName, 
    setShowSuspendSite, 
    setShowChangeCCTV, 
    setMonitoringArc, 
    setShowChangeSerialNumber, 
    setChangePhoneNumber, 
    hasSecondValue, 
    value2, 
    setChangeUsername, 
    setChangeEmailAddress,
    setChangeLockName,
    setChangeBillable,
    setPINVisible,
    setChangeOwnedBy,
    setChangeBilledTo,
    setNavigateToLinkedSite,
    setNavigateToGroup,
    isAllowedToChange,
    setUnauthorisedClick,
    setNavigateToLiveView, 
    deviceUUID,
    editable,
    countryCodeOptions,
    countryCode, 
    setCountryCode,
    showCountryDropdown,
    setShowCountryDropdown,
    setSiteLocation,
    siteType,
    setSiteType, 
    showSiteTypeDropdown, 
    setShowSiteTypeDropdown,
    siteTypeOptions,
    setSiteLocationType,
    setChangeGatewayName,
    setChangeBillingFrequency,
    setChangeDateOfFirstInvoice,
    setNotificationsState,
    setChangeDateOfLastInvoice,
    setChangeDateMadeActive,
    setChangeCustomerNumber,
    renderHalfSize,
    setChangePoweredBy
}, props) => {

    const dataManager = new DataManager()
    const [isMoblie, setIsMoblie] = useState(false)
    const [cssClass, setCssClass] = useState({ stroke: "var(--Primary-Color2)", height: 47.5, speed: 1.5 });
    const navigate = useNavigate();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 430px)'); // Define your media query here

        // Function to handle changes in the media query
        const handleIsMobile = () => {
            if (window.innerWidth <= 430) {
                setIsMoblie(true)

            } else {
                setIsMoblie(false)
            }
        };

        // Initial check for if screen has been resized
        handleIsMobile(mediaQuery);

        // Add event listener for changes in the media query
        mediaQuery.addListener(handleIsMobile);

        // Clean up by removing event listener when component unmounts
        return () => {
            mediaQuery.removeListener(handleIsMobile);
        };
    }, []);

    useEffect(() => {
        if (!isMoblie) {
            setCssClass({ stroke: "var(--Primary-Color)", height: 30.5, speed: 1.5 });
        } else if (isMoblie) {
            setCssClass({ stroke: "var(--Primary-Color)", height: 30, speed: 1.5 });
        }
    }, [isMoblie]);

    const handleOfflineSitesClick = () => {
        navigate("/Dashboard/Offline");
        mixpanel.track("Offline controllers stats card clicked", {
            user: localStorage.getItem('email'),
        });
    };
    const handleOnlineSitesClick = () => {
        navigate("/Dashboard/AllSites");
        mixpanel.track("Online sites stats card clicked", {
            user: localStorage.getItem('email'),
        });
    };
    const handleAllSitesClick = () => {
        navigate("/Dashboard/AllSites");
        mixpanel.track("All sites stats card clicked", {
            user: localStorage.getItem('email'),
        });
    };
    const handleUsersClick = () => {
        navigate("/Dashboard/Users");
    };
    const handlePadlocksClick = () => {
        navigate("/Dashboard/Padlocks");
    };
    const handleKeyboxesClick = () => {
        navigate("/Dashboard/Keyboxes");
    };
    const handleSensorsClick = () => {
        navigate("/Dashboard/Sensors");
    };
    const handleGatewaysClick = () => {
        navigate("/Dashboard/Gateways");
    };
    const handleAccountsClick = () => {
        navigate("/Dashboard/Groups");
    };
    const handleActiveSitesClick = () => {
        navigate("/Dashboard/ActiveSites");
        mixpanel.track("Active sites stats card clicked", {
            user: localStorage.getItem('email'),
        });
    }
    const handleEmptySitesClick = () => {
        navigate("/Dashboard/InactiveSites")
        mixpanel.track("Inactive sites stats card clicked", {
            user: localStorage.getItem('email'),
        });
    }
    const handleControllersClick = () => {
        navigate("/Dashboard/Controllers");
        mixpanel.track("Controllers stats card clicked", {
            user: localStorage.getItem('email'),
        });
    };
    const handleChangeNotifications = () => {
        setChangeNotifications(true);
    }
    const handleChangePortalAdmin = () => {
        setChangePortalAdmin(true);
    }
    const handleSitesOnScheduleClick = () => {
        navigate("/Dashboard/ScheduledActions");
    }
    const handleWithHolidayModeClick = () => {
        setHolidayModeFilter();
    }
    const handleTotalSitesOnScheduleClick = () => {
        allSitesFilter();
    }
    const handleIntegrationClick = () => {
        navigate("/Dashboard/CCTVIntegrations")
    }
    const handleNavigateToLiveView = () => {
        navigate("/Dashboard/LiveViewSites")
    }

    const handleNavigateToCameraList = () => {
        navigate(`/Dashboard/LiveViewSites/Site/${deviceUUID}`)
    }

    const showMonitoredBy = () => {
        //TEMP REMOVAL
        setShowMonitoredByDropdown(true)
    }

    const showCountry = () => {
        //TEMP REMOVAL
        setShowCountryDropdown(true)
    }

    const showSiteType = () => {
        //TEMP REMOVAL
        setShowSiteTypeDropdown(true)
    }

    const handleSetMonitoredBy = (e) => {
        setMonitoringArc(e)
        setShowMonitoredByDropdown(false)
    }

    const handleSetCountryCode = (e) => {
        setCountryCode(e.name)
        setSiteLocation(e.code)
        setShowCountryDropdown(false)
    }

    const handleSetSiteType = (e) => {
        setSiteType(e.label)
        setSiteLocationType(e.label)
        setShowSiteTypeDropdown(false)
    }

    const handleSetNotificationState = () => {
        setNotificationsState(true)
    }

    let specialClasses = null;
    let icon;

    if (title === 'Total users' || title === "Users" || title === "Total portal users") {
        specialClasses = classes.users;
        icon = usersIcon;
    }
    if (title === 'Online sites' || title === 'Online iONs') {
        specialClasses = classes.devicesOnline;
        icon = OnlineIcon;
    }
    if (title === 'Offline sites' || title === `Offline iON's` || title === `Offline iON's ` || title === `Total offline iON's` ) {
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon;
    }
    if (title === "Active schedule only sites"){
        specialClasses = classes.devicesOffline;
        icon = sitesOnSchedule
    }
    if (title === "Total padlocks" || title === "Padlocks"){
        specialClasses = classes.totalCount;
        icon = padlockIcon;
    }
    if (title === "Total sensors"|| title === "Sensors"){
        specialClasses = classes.totalCount;
        icon = sensorIcon;
    }
    if (title === "Total keyboxes" || title === "Keyboxes"){
        specialClasses = classes.totalCount;
        icon = keyBoxesIcon;
    }
    if (title === "Total groups" || title === "Groups"){
        specialClasses = classes.totalCount;
        icon = groupsIcon;
    }
    if (title === "Total active users" || title === 'iONs with no users'){
        specialClasses = classes.totalCount;
        icon = usersIcon;
    }
    if (title === 'Total sites'|| title === "All sites") {
        specialClasses = classes.totalCount;
        icon = allSitesIcon;
    }
    if (title === 'All iON count' || title === "iON"){
        specialClasses = classes.totalCount;
        icon = controllerIcon;
    }
    if (title === 'Total groups') {
        specialClasses = classes.totalCount;
        icon = groupsIcon;
    }
    if (title === "Offline for more than 1 month"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Offline for less than 1 month"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Active offline iON's"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Inactive sites"){
        specialClasses = classes.inactiveCount;
        icon = inactiveIcon
    }
    if (title === "Active sites"){
        specialClasses = classes.activeCount;
        icon = activeIcon
    }
    if (title === "Name" ){
        specialClasses = classes.modifiable;
        icon = usersIcon2
    }
    if (title === "Registered by"){
        specialClasses = classes.name;
        icon = usersIcon2
    }
    if (title === "Email address"){
        specialClasses = classes.modifiableEmail;
        icon = usersIcon
    }
    if (title === "Last logged in" || title === "Last updated" ){
        specialClasses = classes.name;
        icon = lastloggedin
    }
    if (title === "Notifications"){
        specialClasses = classes.modifiable;
        icon = enabled
    }
    if (title === "User since" || title === "Registration date" || title === "Date linked"){
        specialClasses = classes.name;
        icon = userSince
    }
    if (title === "App admin"){
        specialClasses = classes.modifiable;
        icon = portalAdmin
    }
    if (title === "Gateways" || title === "Total gateways"){
        specialClasses = classes.totalCount;
        icon = gatewayIconG
    }
    if (title === "Total access"){
        specialClasses = classes.totalAccess;
        icon = allSitesIcon
    }
    if (title === "iONs"){
        specialClasses = classes.physicalController;
        icon = controllerIcon
    }
    if (title === "Virtual iONs"){
        specialClasses = classes.cloudController;
        icon = cloud
    }
    if (title === "Scheduled sites" || title == "Sites on schedule"){
        specialClasses = classes.cloudController;
        icon = sitesOnSchedule
    }
    if (title === "with temporary schedules"){
        specialClasses = classes.withHolidayMode;
        icon = tempIcon
    }

    if (title === "Total sites on schedule"){
        specialClasses = classes.cloudController;
        icon = sitesOnSchedule
    }

    if (title === "Lock ID"){
        specialClasses = classes.name
        icon = IDIcon
    }
    if (title === "Gateway ID"){
        specialClasses = classes.name
        icon = IDIcon
    }
      if (title === "Sensor ID"){
        specialClasses = classes.name
        icon = IDIcon
    }
    if (title === "Timezone"){
        specialClasses = classes.name
        icon = timezone
    }
    if (title === "Internal serial"){
        //clickable
        specialClasses = classes.modifiable
        icon = portalNameIcon
    }

    if (title === "Serial number"){        
        specialClasses = classes.overviewDefaultClickable;
        icon = serial
    }
        
    if (title === "Gateway name"){
        //clickable
        specialClasses = classes.modifiable
        icon = portalNameIcon
    }

      if (title === "Sensor name"){
        //clickable
        specialClasses = classes.modifiable
        icon = portalNameIcon
    }
    if (title === "Linked to" || title === "Output"){
        specialClasses = classes.overviewDefaultClickable
        icon = allSitesIcon
    }
    if (title === "Output") {
        specialClasses = classes.overviewDefaultClickable
        icon = padlockIcon
    }
    if (title === "Master PIN"){
        specialClasses = classes.nameRed
        icon = master
    }
    if (title === "Battery"){
        specialClasses = classes.name
        icon = battery
    }
    if (title === "Signal"){
        specialClasses = classes.name
        icon = signal
    }
    if (title === "Billable"){
        specialClasses = classes.modifiable
        icon = billable
    }

    if (title === "Billing frequency"){
        specialClasses = classes.modifiable
        icon = userSince
    }
    if (title === "Date made active"){
        specialClasses = classes.modifiable
        icon = lastloggedin
    }
    if (title === "Date of hardware invoice"){
        specialClasses = classes.modifiable
        icon = lastloggedin
    }
    if (title === "Date of 1st SaaS invoice"){
        specialClasses = classes.modifiable
        icon = lastloggedin
    }
    if (title === "Used by"){
        specialClasses = classes.overviewDefaultClickable
        icon = usedBy
    }
    if (title === "Owned by"){
        specialClasses = editable ? classes.modifiable : classes.overviewDefault;
        icon = ownedBy
    }
    if (title === "Billed to"){
        specialClasses = classes.modifiable
        icon = billedTo
    }
        if (title === "Customer billed to"){
        specialClasses = editable ? classes.modifiable : classes.overviewDefault
        icon = billedTo
    }
    //Site Overview
    if (title === "Group" || title === "Group "){
        specialClasses = classes.overviewDefaultClickable;
        icon = groupsIcon
    }
    if (title === "Site ID"){
        specialClasses = classes.overviewDefault;
        icon = IDIcon
    }
    if (title === "Portal site name" || title === "Portal site name "){
        specialClasses = classes.overviewDefaultClickable;
        icon = portalNameIcon
    }
    if (title === "My app site name"){
        specialClasses = classes.overviewDefaultClickable;
        icon = appNameIcon
    }
    if (title === "Firmware"){
        specialClasses = classes.overviewDefault;
        icon = firmwareIcon
    }
    if (title === "No. of users"){
        specialClasses = classes.overviewDefault;
        icon = usersIcon
    }
    if (title === "IP address"){
        specialClasses = classes.overviewDefault;
        icon = IPIcon
    }
    if (title === "MAC address"){
        specialClasses = classes.overviewDefault;
        icon = macIcon
    }
    if (title === "Status" || title === "Network type" || title === "Type"){
        specialClasses = classes.overviewDefault;
        icon = statusIcon
    }
    if (title === "Suspended"){
        specialClasses = classes.overviewDefaultClickable;
        icon = suspendedIcon
    }
    if (title === "Offline since"){
        specialClasses = classes.overviewDefault;
        icon = placeholder
    }
    if (title === "Created" || title === "Active since" || title === "Created by"){
        specialClasses = classes.overviewDefault;
        icon = createdIcon
    }
    if (title === "License type"){
        specialClasses = classes.overviewDefault;
        icon = licenceIcon
    }
    if (title === "Live view enabled"){
        specialClasses = classes.overviewDefault;
        icon = liveViewNewIcon
    }
    if (title === "CCTV integration type"){
        specialClasses = classes.overviewDefaultClickable;
        icon = cctvType
    }
    if (title === "Monitored by"){
        specialClasses = classes.overviewDefaultClickable;
        icon = monitored
    }
    if (title === "Site location"){
        specialClasses = classes.overviewDefaultClickable;
        icon = world
    }
    if (title === "Site type"){
        specialClasses = classes.overviewDefaultClickable;
        icon = siteTypeIcon
    }

    if (title === "Access restrictions"){
        specialClasses = classes.overviewDefault;
        icon = restriction
    }

    if (title === "Internal serial"){
        specialClasses = classes.overviewDefaultClickable;
        icon = serial
    }
    if (title == "Unlinked padlocks"){
        specialClasses = classes.unlinkedCount;
        icon = unlinkedIcon;
    }
    if (title == "Unlinked keyboxes"){
        specialClasses = classes.unlinkedCount;
        icon = unlinkedIcon;
    }
    if (title == "Phone number"){
        specialClasses = classes.modifiable
        icon = phoneIcon
    }

    if (title == "Customer number"){
        specialClasses = classes.modifiable
        icon = customerIcon
    }


    if (title == "Total integrations"){
        icon = cctvType
        specialClasses = classes.totalIntegrations
    }
    if (title == "AJAX") {
        icon = ajaxIcon
        specialClasses = classes.ajax
    }
    if (title == "Hikvision"){
        icon = hikIcon
        specialClasses = classes.hikvision
    }
    if (title == "Dahua"){
        icon = dahuaIcon
        specialClasses = classes.dahua
    }
    if (title == "AIBox"){
        icon = aiboxIcon
        specialClasses = classes.aibox
    }
    if (title == "Origin"){
        specialClasses = classes.name;
        icon = origin
    }
    if (title === "Billable padlocks" || title === "Billable keyboxes" || title === "Billable gateways"){
        specialClasses = classes.totalCount;
        icon = billable
    }
    if (title === "Device type"){
        specialClasses = classes.name;
        icon = deviceIcon
    }
    if (title === "Padlocks on active sites"){
        specialClasses = classes.devicesOnline;
        icon = activeLock
    }
    if (title === "Keyboxes on active sites"){
        specialClasses = classes.devicesOnline;
        icon = activeLock
    }

    if (title === "Billable padlocks " || title === "Billable keyboxes "){
        specialClasses = classes.totalCount;
        icon = billable
    }
    if (title === "Live view enabled sites"){
        specialClasses = classes.totalCount;
        icon = liveViewIcon
    }
    if (title === "Sites with cameras"){
        specialClasses = classes.totalCount;
        icon = cameraIcon
    }
    if (title === "Linked camera count"){
        specialClasses = classes.overviewDefault;
        icon = cameraIcon
    }
    if (title === "Total live view enabled sites"){
        specialClasses = classes.totalCount;
        icon = liveViewIcon
    }
    if (title === "With a camera linked"){
        specialClasses = classes.totalCount;
        icon = cameraIcon
    }
    if (title === "Total linked cameras"){
        specialClasses = classes.totalCount;
        icon = cameraIcon
    }

    if (title === "Unstable CCTV connections"){
        specialClasses = classes.devicesOffline
        icon = unstableCCTV
    }
    if(title === "Site notifications"){
        specialClasses = classes.overviewDefaultClickable;
        icon = enabled
    }

    if(title === "Offline gateways"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if(title === "Check-in missed"){
        specialClasses = classes.staleGateways;
        icon = OfflineIcon
    }
    if(title === "Critical (<10% battery)"){
        specialClasses = classes.devicesOffline;
        icon = battery0
    }
    if(title === "Critical (<5% battery)"){
        specialClasses = classes.devicesOffline;
        icon = battery0
    }
    if(title === "Warning (<30% battery)"){
        specialClasses = classes.emptyCount;
        icon = battery25
    }
    if(title === "Warning (<20% battery)"){
        specialClasses = classes.emptyCount;
        icon = battery25
    }
    if(title === "Healthy (>30% battery)"){
        specialClasses = classes.devicesOnline;
        icon = battery100
    }
    if(title === "Healthy (>20% battery)"){
        specialClasses = classes.devicesOnline;
        icon = battery100
    }
    if(title === "Billable "){
        specialClasses = classes.totalCount;
        icon = billable
    }
     if(title === "Non-billable"){
        specialClasses = classes.totalCount;
        icon = billable
    }
    if(title === "Powered by"){
        specialClasses = setChangePoweredBy ? classes.modifiable : classes.overviewDefault;
        icon = power
    }
     if(title === "Billable sites"){
        specialClasses = classes.totalCount;
        icon = billable
    }
    if(title === "Schedule events"){
        specialClasses = classes.totalCount;
        icon = schedule
    }
    if(title === "Successful triggers"){
        specialClasses = classes.totalCount;
        icon = arm
    }
    if(title === "Failed triggers"){
        specialClasses = classes.redStat;
        icon = disarm
    }
    if(title === "Success rate") {
        specialClasses = classes.devicesOnline;
        icon = success
    }

    const cssClasses = `${classes['Top-left']} ${specialClasses}`;

    const changeGroup = () => {
        setShowChangeGroup(true)
    }

    const changePortalName = () => {
        setShowChangePortalName(true)
    }

    const changeAppName = () => {
        setShowChangeName(true)
    }

    const changeSuspendedStatus = () => {
        setShowSuspendSite(true)
    }

    const changeCCTVIntegrationType = () => {
        if(value == "Whole camect" || value == "Per camera arming"){ //TODO - change this to check if it should be enabled by RE:SURE instead
           setShowChangeCCTV(true) 
        }
    }

    const setSerialNumber = () => {
        setShowChangeSerialNumber(true)
    }

    const setPhoneNumber = () => {
        setChangePhoneNumber(true)
    }

    const setUsername = () => {
        setChangeUsername(true)
    }

    const setEmailAddress = () => {
        setChangeEmailAddress(true)
    }

    const setShowChangeLockName = () => {
        setChangeLockName(true)
    }

    const setShowChangeGatewayName = () => {
        setChangeGatewayName(true)
    }

    const changeOwnedBy = () => {
        setChangeOwnedBy(true)
    }

    const changeBilledTo = () => {
        setChangeBilledTo(true)
    }

    const navigateToLinkedSite = () => {
        setNavigateToLinkedSite(true)
    }

    const navigateToGroup = () => {
        setNavigateToGroup(true)
    }

    const navigateToLiveView = () => {
        setNavigateToLiveView(true)
    }

    const changeBillable = () => {
        if (isAllowedToChange){
            setChangeBillable(true)
        } else {
            setUnauthorisedClick(true)
        }
    }

    const changeBillingFrequency = () => {
        setChangeBillingFrequency(true)
    }

    const changeDateOfFirstInvoice = () => {
        setChangeDateOfFirstInvoice(true)
    }

    const changeDateOfLastInvoice = () => {
        setChangeDateOfLastInvoice(true)
    }

    const changeDateMadeActive = () => {
        setChangeDateMadeActive(true)
    }

    const changeCustomerNumber = () => {
        setChangeCustomerNumber(true)
    }

    const changePoweredBy = () => {
        setChangePoweredBy(true)
    }
    
    console.log(renderHalfSize);

return (
  <div
    className={renderHalfSize ?  `${classes.containerHalf}` : `${classes.container} ${props.container} `}
    {...(title === `Offline iON's` || title === `Offline iON's` ? { onClick: handleOfflineSitesClick} : {})}
    {...(title === 'Online sites' ? { onClick: handleOnlineSitesClick } : {})}
    {...(title === 'All sites' ? { onClick: handleAllSitesClick } : {})}
    {...(title === 'Users' ? { onClick: handleUsersClick } : {})}
    {...(title === 'Padlocks' ? { onClick: handlePadlocksClick } : {})}
    {...(title === 'Sensors' ? { onClick: handleSensorsClick } : {})}
    {...(title === 'Gateways' ? { onClick: handleGatewaysClick } : {})}
    {...(title === 'Keyboxes' ? { onClick: handleKeyboxesClick } : {})}
    {...(title === 'Groups' ? { onClick: handleAccountsClick } : {})}
    {...(title === 'Active sites' ? { onClick: handleActiveSitesClick } : {})}
    {...(title === 'Inactive sites' ? { onClick: handleEmptySitesClick } : {})}
    {...(title === 'iONs' ? { onClick: handleControllersClick } : {})}
    {...(title === 'Notifications' && editable ? { onClick: handleChangeNotifications } : {})}
    {...(title === 'App admin' && editable ? { onClick: handleChangePortalAdmin } : {})}
    {...(title === 'Sites on schedule' ? { onClick: handleSitesOnScheduleClick} : {})}
    {...(title === 'Serial number' && editable ? { onClick: setSerialNumber } : {})}

    {...(title === 'Total sites on schedule' ? { onClick: handleTotalSitesOnScheduleClick} : {})}
    {...(title === 'with temporary schedules' ? { onClick: handleWithHolidayModeClick} : {})}
    {...(title === 'Scheduled sites' ? { onClick: handleSitesOnScheduleClick} : {})}
    {...(title === 'Monitored by' && editable ? { onClick: showMonitoredBy } : {})}
    {...(title === 'Site location' && editable ? { onClick: showCountry } : {})}
    {...(title === 'Site type' && editable ? { onClick: showSiteType } : {})}
    {...(title === 'Group' && editable ? { onClick: changeGroup } : {})}
    {...(title === 'Portal site name' && editable ? { onClick: changePortalName } : {})}
    {...(title === 'My app site name' && editable ? { onClick: changeAppName } : {})}
    {...(title === 'Suspended' && editable ? { onClick: changeSuspendedStatus } : {})}
    {...(title === 'CCTV integration type' && editable ? { onClick: changeCCTVIntegrationType } : {})}
    {...(title === 'Internal serial' && editable ? { onClick: setSerialNumber } : {})}
    {...(title === 'Phone number' && editable ? { onClick: setPhoneNumber } : {})}
    {...(title === 'Name' && editable ? { onClick: setUsername } : {})}
    {...(title === 'Email address' && editable ? { onClick: setEmailAddress } : {})}
    {...(title === 'Total integrations'
            || title == "AJAX"
            || title == "Hikvision"
            || title == "Dahua"
            || title == "AIBox" ? { onClick: handleIntegrationClick } : {})}
    {...(title === 'Internal serial' && editable ? { onClick: setShowChangeLockName } : {})}
    {...(title === 'Gateway name' && editable ? { onClick: setShowChangeGatewayName } : {})}
    {...(title === 'Sensor name' && editable ? { onClick: setShowChangeGatewayName } : {})}

    {...(title === 'Billable' && editable ? { onClick: changeBillable } : {})}
    {...(title === 'Billing frequency' && editable ? { onClick: changeBillingFrequency } : {})}
    {...(title === 'Date of hardware invoice' && editable ? { onClick: changeDateOfFirstInvoice } : {})}
    {...(title === 'Date of 1st SaaS invoice' && editable ? { onClick: changeDateOfLastInvoice } : {})}
    {...(title === 'Date made active' && editable ? { onClick: changeDateMadeActive } : {})}

    {...(title === "Master PIN"
        ? {
            onMouseDown: () => setPINVisible(true),
            onMouseUp: () => setPINVisible(false),
            onMouseLeave: () => setPINVisible(false), // in case they drag off
            onTouchStart: () => setPINVisible(true),
            onTouchEnd: () => setPINVisible(false),
            }
        : {})}
    {...(title === 'Owned by' && editable ? { onClick: changeOwnedBy } : {})}
    {...(title === 'Billed to' && editable ? { onClick: changeBilledTo } : {})}
    {...(title === 'Customer billed to' && editable ? { onClick: changeBilledTo } : {})}
    {...(title === 'Linked to' || title === "Output" ? { onClick: navigateToLinkedSite } : {})}
    {...(title === 'Used by' ? { onClick: navigateToGroup } : {})}
    {...(title === 'Live view sites' ? { onClick: handleNavigateToLiveView } : {})}
    {...(title === 'Sites with cameras' ? { onClick: handleNavigateToLiveView } : {})}
    {...(title === 'Site notifications' && editable ? { onClick: handleSetNotificationState } : {})}
    {...(title === 'Customer number' && editable ? { onClick: changeCustomerNumber } : {})}
    {...(title === 'Powered by' && editable ? { onClick: changePoweredBy } : {})}


  >
    <div className={classes["Top"]}>
      <h3>{title}</h3>
      {!isStatic && <TimerIndicator className={classes["TimeStatus-component"]} status={status} />}
    </div>

    <div className={classes["Bottom"]}>
      <div className={cssClasses}>
        {isLoadingStats ? (
          <Oval stroke={cssClass.stroke} height={cssClass.height} speed={cssClass.speed} />
        ) : (
            <div className={classes.headingWithSmall}>
                <h1>{value}</h1>
                { hasSecondValue && <small style={{fontSize:"9px"}}>{`(${value2} active)`}</small>}
            </div>
        )}
      </div>
      {title === "Email address" && 
      
       <>
                {editable == true && <img style={{width:"22px", height:"22px", paddingRight:"0px", gap:"8px"}}className={classes.icon} alt={`${title} icon`} src={editIcon} />}
               
            </>

        }
        {title !== "Email address" && 
            <>
                {editable == true && <img style={{width:"22px", height:"22px", paddingRight:"0px", gap:"8px"}}className={classes.icon} alt={`${title} icon`} src={editIcon} />}
                <img className={classes.icon} alt={`${title} icon`} src={icon} />
               
            </>
                        

        }
    </div>

    {title === "Notifications" && (
      <div className={classes.activeSites}>
        <p>{value == "Enabled" ? "Click to disable notifications" : "Click to enable notifications" }</p>
      </div>
    )}

    {title === "App admin" && (
      <div className={classes.activeSites}>
        <p>{value == "Yes" ? "Click to disable app admin" : "Click to enable app admin" }</p>
      </div>
    )}

    {title === "Phone number" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit phone number"}</p>
      </div>
    )}

    {title === "Name" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit name"}</p>
      </div>
    )}

    {title === "Email address" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit email address"}</p>
      </div>
    )}

    {(
        
        title === "with temporary schedules" ||
        title === "Total sites on schedule"
    ) && (
        <div className={classes.activeSites}>
            <p>Click to apply filter</p>
        </div>
    )}

    { title === "Offline iON's " && (
         <div className={classes.activeSites}>
            <p>Click to view</p>
        </div>
    )}

    { title === "Master PIN" && (
         <div className={classes.activeSites}>
            <p>Click and hold to view</p>
        </div>
    )}

    {title === "Lock name" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Gateway name" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billable" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billing frequency" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Date of hardware invoice" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Date made active" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Date of 1st SaaS invoice" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Owned by" && editable && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billed to" && editable && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

     {title === "Customer billed to" && editable && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Powered by" && setChangePoweredBy && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {(title === "Billable padlocks"  && !renderHalfSize)&& (
        <div className={classes.activeSites}>
            <small style={{fontSize:"9px"}}>On active sites billed to this group </small>
        </div>
    )}

    {(title === "Billable keyboxes" && !renderHalfSize) && (
        <div className={classes.activeSites}>
            <small style={{fontSize:"9px"}}>On active sites billed to this group</small>
        </div>
    )}


    {title === "Monitored by" && showMonitoredByDropdown && (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown 
          value={monitoredBy} 
          onChange={(e) => handleSetMonitoredBy(e.value)}
          options={monitoredByOptions}
          optionLabel="name"
          placeholder="Select an option" 
          className="w-full md:w-14rem" 
        />
      </div>
    )}

    {title === "Site location" && showCountryDropdown && (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown 
        filter
          value={countryCode} 
          onChange={(e) => handleSetCountryCode(e.value)}
          options={countryCodeOptions}
          optionLabel="name"
          placeholder="Select an option" 
          className="w-full md:w-14rem" 
        />
      </div>
    )}
    {title === "Site type" && showSiteTypeDropdown && (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown 
        filter
          value={siteType} 
          onChange={(e) => handleSetSiteType(e.value)}
          options={siteTypeOptions}
          optionLabel="label"
          placeholder="Select an option" 
          className="w-full md:w-14rem" 
        />
      </div>
    )}

    {title === "Empty sites" && (
      <div className={classes.activeSites}>
        <p>Online sites with 0 users & no portal name</p>
      </div>
    )}
  </div>
);

}


export default Stats2;